import React from "react";
import Navbar from './Navbar';
import { Link } from 'react-router-dom';
import logoVS from '../../files/img/LOGO-VS-BIANCO.png';
import LogoutButton from "../../../LogoutButton";
import NotificationAPIComponent from "../notifiche/NotificationAPI";
import HeaderMessageTicker from "../headerMessage/HeaderMessageTicker";

function Header({
  autenticazione,
  mobile,
  temaColori
}) {
  

  const ambiente = process.env.REACT_APP_AMBIENTE;
  let title = autenticazione.title+"";

  if (ambiente !== "prod") {
    title = autenticazione.title+" / "+ambiente
  }

  return (
    <header>
      <div className="nav-area">
        <div className="altezzaHeader flex items-center">
          <Link to="/" className="logo b items-center">
            {!mobile && <img src={logoVS} width='30px' className="v-mid mr2" alt='Logo'></img>}
            {mobile && <span class="material-symbols-outlined">arrow_back</span>}
            {!mobile && <span className="v-mid ttu dn relative-l">{title}</span>}
          </Link>
          {!mobile && <Navbar autenticazione={autenticazione} temaColori={temaColori} mobile={mobile}/>}
        </div>
        {!mobile && <HeaderMessageTicker />}
        {mobile && <div>{autenticazione.username}</div>}
        <div className="header-user-area">
        {!mobile && <div className="sezioneBarraUtente dn flex-l">
          {/* {"autenticazione.username",autenticazione.username} */}
          <NotificationAPIComponent userId={autenticazione.username} />
          {/* {autenticazione && autenticazione.emoji && <span className="mr2">{autenticazione.emoji}</span>} */}
          {autenticazione.permessiAPI["update:database"] ?
           <small className='pr3 dtc'>Ciao <strong>{autenticazione.nickname}</strong>, non fare casini</small>
            : <small className='pr3 dtc'>{autenticazione.nickname}</small>
          }
          <div className="logout-button-container-barraAlto pr3 dtc"><LogoutButton /></div>
        </div>}
        {mobile && <div className="sezioneBarraUtente dn-ns dn-m">
          <LogoutButton mobile={mobile}/>
        </div>}
        </div>
        
        
        

      </div>
    </header>
  )
}

export default Header;